export default angular.module('GeoDataExportApp', [
    'KhBase'
]);
